import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const QuestionnaireStatusFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.QUESTIONNAIRE_STATUS}
        filterName={FilterName.QUESTIONNAIRE_STATUS}
        valueKey="questionnaireStatuses"
        isNested={isNested}
      />
    )
  },
)
